import { Link, NavLink } from "react-router-dom";

function Navbar() {
  return (
    <header className="site-header">
      <nav className="navbar">
        <Link to="/" className="brand">Vision Forte</Link>
        <input id="nav-toggle" type="checkbox" className="nav-toggle" />
        <label htmlFor="nav-toggle" className="hamburger" aria-label="Toggle navigation">
          <span></span>
          <span></span>
          <span></span>
        </label>
        <ul className="nav-links">
          <li>
            <NavLink to="/" end>Home</NavLink>
          </li>
          <li>
            <NavLink to="/services">Services</NavLink>
          </li>
          <li>
            <NavLink to="/about">About Us</NavLink>
          </li>
          <li>
            <NavLink to="/contact">Contact</NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
